"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePendingID = exports.addPendingID = exports.REMOVE_PENDING_ID = exports.ADD_PENDING_ID = exports.PENDING_ID = void 0;
exports.PENDING_ID = '[PendingID]';
exports.ADD_PENDING_ID = `${exports.PENDING_ID} ADD`;
exports.REMOVE_PENDING_ID = `${exports.PENDING_ID} REMOVE`;
const addPendingID = ({ id }) => ({
    type: exports.ADD_PENDING_ID,
    payload: id,
    meta: { feature: exports.PENDING_ID },
});
exports.addPendingID = addPendingID;
const removePendingID = ({ id }) => ({
    type: exports.REMOVE_PENDING_ID,
    payload: id,
    meta: { feature: exports.PENDING_ID },
});
exports.removePendingID = removePendingID;
//# sourceMappingURL=pendingIDs.js.map